"use client";
import SearchSuspense from "./Suspense/Index";
import { useEffect, useState } from "react";
import pulseConfig from "@/pulsex.config";
const API_URL = pulseConfig.API_URL;

const SearchPage = ({ isMobile }: any) => {
  const [filterTypes, setFilterTypes] = useState<any>();

  useEffect(() => {
    const fetchSections = async () => {
      try {
        const response = await fetch(API_URL + "/assets/searchSections");
        if (!response.ok) {
          throw new Error(`Error: ${response?.status}`);
        }
        const data = await response?.json();
        if (data) {
          const values = data["الكل"];
          setFilterTypes(values);
        }
      } catch (err: unknown) {
        console.log("error occured");
      }
    };

    fetchSections();
  }, []);

  return (
    <>
      <main className="min-h-screen block w-full container">
        <SearchSuspense isMobile={isMobile} types={filterTypes} />{" "}
      </main>
    </>
  );
};

export default SearchPage;
